/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * DrugCoverageTier
 */
export enum DrugCoverageTier {
  generic = 'generic',
  specialty = 'specialty',
  brand = 'brand',
  preferredBrand = 'preferredBrand',
  preferredGeneric = 'preferredGeneric',
  preferredSpecialty = 'preferredSpecialty',
  nonPreferredBrand = 'nonPreferredBrand',
  nonPreferredGeneric = 'nonPreferredGeneric',
  nonPreferredSpecialty = 'nonPreferredSpecialty',
  notCovered = 'notCovered',
  notListed = 'notListed',
  nonListed = 'nonListed',
  noCoverage = 'noCoverage',
}
